import React from "react";
import ReactExport from "react-export-excel";
import { Container, Row, Col, FormGroup, Button } from 'reactstrap';
import DatePicker from "../Form/DatePicker";
import { FormLabel } from "../Form/FormLabel";
import moment from 'moment';
import { useState } from "react";
import { endpoints } from "../../utils/Constants";
import { useEffect } from "react";
import LoadingAnimation from "../Form/LoadingAnimation";
import useFetchSimple from '../../Services/useFetchSimple';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const PayLoadReportExport= ({ exportType }) => {

    const thisQuarter = parseInt((new Date().getMonth() + 1) / 3);
    const year = thisQuarter === 0 ? new Date().getFullYear() - 1 : new Date().getFullYear();
    const lastQuarter = thisQuarter === 0 ? 4 : thisQuarter - 1;
    const fromDate = new Date(year, (lastQuarter * 3) - 1, 1);
    const toDate = new Date(year, lastQuarter * 3 + 2, 1);
    const [fromDateSelected, setFrom] = useState(moment(fromDate));
    const [toDateSelected, setTo] = useState(moment(toDate));    
     
    const [reportDetails, setReportDetails] = useState();
    const [initialReportDetails, setInitialReportDetails] = useState();
   
   
    const handleChangeFrom = (e) => {
        setFrom(moment(e));
        
        setReportDetails(initialReportDetails.filter( book => new Date(book.depatureTime).getTime() >= e && 
        new Date(book.depatureTime).getTime() <= toDateSelected));
    };    

    const handleChangeTo = (e) => {
        setTo(moment(e));
        setReportDetails(initialReportDetails.filter( book => new Date(book.depatureTime).getTime() >= fromDateSelected && 
                        new Date(book.depatureTime).getTime() <= e));
    };

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  //const [isLoaded, setIsLoaded] = useState(false); 
  const fetch = useFetchSimple(); 


  useEffect(() => {
    fetch(endpoints.payloadReport)
      .then(res => res)
      .then(
        (result) => {
          //setIsLoaded(true);         
          setReportDetails(result.body);
          setInitialReportDetails(result.body);
          setLoading(false);          
        },       
        (error) => {
          //setIsLoaded(true);
          setError(error);
          setLoading(false);
        }
      )
  }, []);  

    return <Container>
        {<Row>
            <Col>
                <FormGroup>
                    <FormLabel>From</FormLabel>
                    <DatePicker disabled={loading} type='datetime-local' placeholder="Report From" onChange={handleChangeFrom} selected={moment(fromDateSelected).toDate()} />
                </FormGroup>
            </Col>
            <Col>
                <FormGroup>
                    <FormLabel>To</FormLabel>
                    <DatePicker disabled={loading}  type='datetime-local' placeholder="Report To" onChange={handleChangeTo} selected={moment(toDateSelected).toDate()} />
                </FormGroup>
            </Col>
        </Row>}
        {loading ? <LoadingAnimation /> :  null}     
        {error ? <h5>Error Loading Report</h5> : null}
        {(reportDetails) ? <ExcelFile element={<button type='button'>Download Data</button>}>
            {reportDetails ? <ExcelSheet data={reportDetails} name="Payload Report">

                <ExcelColumn label='Job' value={(detail) => {
                    return ('JB'+detail.jobReference)
                }} />
         
                <ExcelColumn label='Depature Time' value={(detail) => {
                    return detail.depatureTime
                }} />
                <ExcelColumn label='Aircraft' value={(detail) => {
                    return detail.aircraft
                }} />
                <ExcelColumn label='Route' value={(detail) => {
                    return detail.route
                }} />              
                <ExcelColumn label='Total Seats' value={(detail) => {
                    return detail.totalSeats
                }} />
                <ExcelColumn label='Seats Booked' value={(detail) => {
                    return detail.seatsBooked;
                }} />
                 <ExcelColumn label='Seats Availalable' value={(detail) => {
                    return (detail.totalSeats-detail.seatsBooked)
                }} />

                <ExcelColumn label='Estimated Max Payload' value={(detail) => {
                    return detail.maxPayLoad
                }} />
                
                <ExcelColumn label='Payload Used' value={(detail) => {
                    return detail.payLoadUsed
                }} />
               
                <ExcelColumn label='Payload Availalable' value={(detail) => {
                    return (detail.maxPayLoad-detail.payLoadUsed)
                }} />

                 <ExcelColumn label='Client Department'  value={(detail) => {
                    return detail.clientDepartment
                }} />              

            </ExcelSheet> : null}
        </ExcelFile> : null}
    </Container>;

}

export default PayLoadReportExport